import { Link } from "react-router-dom";
import { fileUrl } from "../lib/api";
import { MapPin, Briefcase, GraduationCap, BadgeCheck } from "lucide-react";

export default function ProfileCard({ profile, index = 0 }) {
  const cover = (profile.photos && profile.photos[0]) ? fileUrl(profile.photos[0]) : null;
  return (
    <Link
      to={`/profile/${profile.id}`}
      data-testid={`profile-card-${profile.id}`}
      className="group block rise"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative overflow-hidden rounded-2xl bg-[#F2EFE9] aspect-[4/5] lift-on-hover">
        {cover ? (
          <img
            src={cover}
            alt={profile.full_name}
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            loading="lazy"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-[#8C857B] font-serif-display text-5xl">
            {profile.full_name?.[0] || "?"}
          </div>
        )}
        <div className="absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-black/70 to-transparent" />
        <div className="absolute bottom-5 left-5 right-5 text-white">
          <div className="font-serif-display text-2xl leading-tight inline-flex items-center gap-2">
            {profile.full_name}
            {profile.verified && <BadgeCheck className="h-4 w-4 text-[#E2DCD0]" strokeWidth={2} aria-label="Verified"/>}
          </div>
          <div className="text-xs mt-1 text-white/80 flex items-center gap-2 flex-wrap">
            {profile.age && <span>{profile.age} yrs</span>}
            {profile.city && <><span className="opacity-50">·</span><span className="inline-flex items-center gap-1"><MapPin className="h-3 w-3" strokeWidth={1.5}/>{profile.city}</span></>}
          </div>
        </div>
      </div>
      <div className="mt-3 px-1 text-sm text-[#8C857B] flex items-center gap-3 flex-wrap">
        {profile.profession && <span className="inline-flex items-center gap-1"><Briefcase className="h-3.5 w-3.5" strokeWidth={1.5}/>{profile.profession}</span>}
        {profile.education && <span className="inline-flex items-center gap-1"><GraduationCap className="h-3.5 w-3.5" strokeWidth={1.5}/>{profile.education}</span>}
      </div>
    </Link>
  );
}
